'use strict';

var _ = require('lodash');
var AdvancedValidationModel = require('lib/models/AdvancedValidation');
var networkUtils = require('lib/network');
var snapshotMixin = require('lib/mixins/snapshot');
var i18n = require('i18next');

/**
 * Represents an individual Outbound NAT rule
 */
module.exports = AdvancedValidationModel.extend(snapshotMixin).extend({
  /**
   * @member {Object} actions/outboundNat/EditNat#attributes
   * @property {Boolean} remove
   *   Whether the rule should be removed on save
   * @property {string} egressIp
   * @property {string} srcIp
   * @property {boolean} enabled
   *  enabled or disabled
   */

  _snapshotAttributes: ['name', 'type', 'egressIp', 'srcIp', 'enabled', 'remove'],

  defaults: {
    remove: false,
    enabled: true,
  },

  validate: function(attrs, options) {
    var errors = {};

    if (this.get('remove') === true) {
      // rules pending removal are never considered invalid
      return;
    }

    var name = attrs.name || this.get('name');
    if (!name || (typeof name === 'string' && name.trim() === '')) {
      errors.name = i18n.t('actionOutboundNat.missingName');
    }

    var srcIp = attrs.srcIp || this.get('srcIp');
    var type = attrs.type || this.get('type');

    if (!srcIp || (typeof srcIp === 'string' && srcIp.trim() === '')) {
      errors.srcIp = i18n.t('actionOutboundNat.missingSource');
    } else {
      if (type === 'network') {
        if (!networkUtils.validInternalSubnet(srcIp)) {
          errors.srcIp = i18n.t('actionOutboundNat.badSubnet');
        }
      } else if (!networkUtils.validInternalIPv4(srcIp)) {
        errors.srcIp = i18n.t('actionOutboundNat.badAddress');
      }

      // Check if source matches egress
      var egressIp = attrs.egressIp || this.get('egressIp');
      if (!errors.srcIp && srcIp === egressIp) {
        errors.srcIp = i18n.t('actionOutboundNat.sourceMatchesEgress');
      }

      // Check for duplicates
      if (!errors.srcIp && this.collection) {
        var cid = this.cid;
        var duplicates = this.collection.filter(function(rule) {
          return rule.cid !== cid && rule.get('srcIp') === srcIp;
        });
        if (duplicates.length > 0) {
          errors.srcIp = i18n.t('actionOutboundNat.duplicateSource');
        }
      }
    }

    if (_.size(errors) > 0) {
      return errors;
    }
  },

  /**
   * @return {Object|undefined}
   */
  getTask: function() {
    if (this.get('remove') === true) {
      return {
        name: 'nat.removeOutboundNat',
        data: {
          id: this.id,
        },
      };
    }

    if (this.isNew() || this.getSnapshotDiff()) {
      var task = {
        name: 'nat.addOutboundNat',
        data: {
          egressIp: this.get('egressIp'),
          name: this.get('name'),
          srcType: this.get('type'),
          srcIp: this.get('srcIp'),
          enabled: this.get('enabled'),
        },
      };

      if (!this.isNew()) {
        task.data.id = this.id;
      }

      return task;
    }
  },
});
